module.exports = window["Swiper"];